import { useEffect } from "react";

const siteUrl = "https://www.axentiaglobal.com";
const defaultOgImage = `${siteUrl}/images/hero-fallback.jpg`;
const defaultDescription = "Axentia Global is a retained executive search firm placing senior leaders across the value chain and corporate functions for businesses in Asia.";

export default function SEO({
  title = "",
  description = defaultDescription,
  path = "",
  image = "",
  type = "website",
  jsonLd = null,
}) {
  const fullTitle = title && title.length > 0
    ? `${title} — Axentia Global`
    : "Axentia Global — Executive Search Across Asia";

  useEffect(() => {
    document.title = fullTitle;

    const updateMeta = (attr, key, content) => {
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };

    const canonicalUrl = `${siteUrl}${path === "/" ? "" : path}` || siteUrl;
    const ogImage = image
      ? (image.startsWith("/") ? `${siteUrl}${image}` : image)
      : defaultOgImage;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    updateMeta('name', 'description', description || defaultDescription);
    updateMeta('property', 'og:title', fullTitle);
    updateMeta('property', 'og:description', description || defaultDescription);
    updateMeta('property', 'og:url', canonicalUrl);
    updateMeta('property', 'og:type', type);
    updateMeta('property', 'og:image', ogImage);
    updateMeta('property', 'og:site_name', 'Axentia Global');
    updateMeta('name', 'twitter:card', 'summary_large_image');
    updateMeta('name', 'twitter:title', fullTitle);
    updateMeta('name', 'twitter:description', description || defaultDescription);
    updateMeta('name', 'twitter:image', ogImage);

    document.querySelectorAll('script[data-seo-jsonld]').forEach((s) => s.remove());
    if (jsonLd) {
      const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      blocks.forEach((block) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-jsonld', '1');
        script.textContent = JSON.stringify(block);
        document.head.appendChild(script);
      });
    }
  }, [fullTitle, description, path, image, type, jsonLd]);

  return null;
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${siteUrl}${item.path === "/" ? "" : item.path}`,
  })),
});

export const professionalServiceLd = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name,
  description,
  url: `${siteUrl}${path}`,
  provider: {
    "@type": "Organization",
    name: "Axentia Global",
    url: siteUrl,
  },
  areaServed: "Asia",
});
